import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const tenantUserMappingMenuRegistry = {
    core_tenantUserMapping: {
        label: "Tenant User Mapping",
        link: PAGE_URL.TENANT_USER_MAPPING_PAGE,
        key: PAGE_URL.TENANT_USER_MAPPING_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default tenantUserMappingMenuRegistry;
